module.exports = __webpack_public_path__ + "img/female-users@2x.9438d4be.png";